var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section-shaped section-lg my-0 login-page"},[_vm._m(0),_c('div',[_c('brands-inpi')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shape shape-style-1 bg-gradient-default"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }